<template>
    <div class="grid">
        <div class="col-12 lg:col-5 ">
            <HorseHistoryChangesDataTable :changes-list="changesHistory" @showRevision="showChangesHistory"/>
        </div>
        <div v-if="selectedVersion" class="selectedVersion col-12 lg:col-7 p-4 ">
            <RevisionInfo :username="selectedModification.username"
                          :timestamp="selectedModification.timestamp"/>
            <div class="separator mb-3 mt-3"/>
            <div class="horse-data">
                <div><span class="label">status: </span>{{selectedVersion?.horseData?.horseStatus}}</div>
                <div><span class="label">name: </span>{{selectedVersion?.horseData?.name}}</div>
                <div><span class="label">local name: </span> {{selectedVersion?.horseData?.localName}}</div>
                <div><span class="label">fullName: </span> {{selectedVersion?.horseData?.fullName}}</div>
                <div><span class="label">gender: </span>{{selectedVersion?.horseData?.sex}}</div>
                <div><span class="label">coat color: </span>{{selectedVersion?.horseData?.colorName}}</div>
                <div><span class="label">UELN: </span>{{selectedVersion?.horseData?.ueln}}</div>
                <div><span class="label">microchip: </span>{{selectedVersion?.horseData?.transponderCode}}</div>
                <div><span class="label">second microchip: </span>{{selectedVersion?.horseData?.secondTransponderCode}}</div>
                <div><span class="label">sire: </span>{{selectedVersion?.horseData?.father}}</div>
                <div><span class="label">dam: </span>{{selectedVersion?.horseData?.mother}}</div>

                <div class="separator mt-1 mb-1"/>

                <div><span class="label">birth date: </span>{{selectedVersion?.horseData?.dateOfBirth}}</div>
                <div><span class="label">birth country: </span>{{selectedVersion?.horseData?.countryOfBirthName}}</div>
                <div><span class="label">import date: </span>{{selectedVersion?.horseData?.dateOfImport}}</div>
                <div><span class="label">import country: </span>{{selectedVersion?.horseData?.countryOfImportName}}</div>
                <div><span class="label">control date: </span>{{selectedVersion?.horseData?.dateOfControl}}</div>
                <div><span class="label">controlled by: </span>{{selectedVersion?.horseData?.controlledByName}}</div>
                <div><span class="label">export date: </span>{{selectedVersion?.horseData?.dateOfExport}}</div>
                <div><span class="label">death date: </span>{{selectedVersion?.horseData?.dateOfDeath}}</div>
                <div><span class="label">strain: </span>{{selectedVersion?.horseData?.strain}}</div>
                <div><span class="label">classification: </span>{{selectedVersion?.horseData?.horseClassification}}</div>
                <div><span class="label">bloodCode: </span>{{selectedVersion?.horseData?.bloodCode}}</div>

                <div class="separator mt-1 mb-1"/>

                <div><span class="label">{{ $t('message.horsePreview.owners.breeders') }}:</span></div>
                <div v-for="breeder in selectedVersion?.horseData?.breeders" :key="breeder.id" class="value ml-3">{{ breeder }}</div>

                <div class="separator mt-1 mb-1"/>

                <div><span class="label">{{ $t('message.horsePreview.owners.owners') }}:</span></div>
                <div v-for="owner in selectedVersion?.horseData?.owners" :key="owner.id" class="value ml-3">{{ owner }}</div>

                <div class="separator mt-1 mb-1"/>

                <div><span class="label">original studbook name: </span>{{selectedVersion?.horseData?.bookTypeAuthority}}</div>
                <div><span class="label">original studbook ref.: </span>{{selectedVersion?.horseData?.previousStudbookRegistryId}}</div>
                <div><span class="label">original studbook vol.: </span>{{selectedVersion?.horseData?.previousBookNumber}}</div>
                <div><span class="label">original studbook supp.: </span>{{selectedVersion?.horseData?.previousBookAppendixNumber}}</div>
                <div><span class="label">original studbook p.: </span>{{selectedVersion?.horseData?.previousBookPage}}</div>

                <div class="separator mt-1 mb-1"/>

                <div><span class="label">current studbook name: </span>{{selectedVersion?.horseData?.previousBookTypeAuthority}}</div>
                <div><span class="label">current studbook ref.: </span>{{selectedVersion?.horseData?.studbookRegistryId}}</div>
                <div><span class="label">current studbook vol.: </span>{{selectedVersion?.horseData?.bookTypeName}}</div>
                <div><span class="label">current studbook supp.: </span>{{selectedVersion?.horseData?.bookAppendixNumber}}</div>
                <div><span class="label">current studbook p.: </span>{{selectedVersion?.horseData?.bookPage}}</div>

                <div class="separator mt-1 mb-1"/>

                <div><span class="label">notes: </span>
                    <div class="notes">
                        {{selectedVersion?.horseData?.notes}}
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {
    getAuditTrail, getRevision
} from "@/swagger/vue-api-client";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import HorseHistoryChangesDataTable
    from "@/views/horse/horseEdit/history/compontents/HorseHistoryChangesDataTable.vue";
import RevisionInfo from "@/views/horse/horseEdit/history/compontents/RevisionInfo.vue";

export default {
    name: "HorseGeneralHistoryTab",

    components: {
        RevisionInfo,
        HorseHistoryChangesDataTable,
        TabPanel,
        TabView
    },

    props: {
        horse: null,
    },

    data() {
        return {
            changesHistory: null,
            selectedVersion: null,
            selectedModification: {
                timestamp: null,
                username: null
            }
        };
    },

    beforeMount() {
        getAuditTrail({id: this.horse.id}).then((response => {
            this.changesHistory = response.data;
            const lastHistoryEntry = this.changesHistory.length > 0 ? this.changesHistory[0] : undefined;
            const lastRevision = lastHistoryEntry ? lastHistoryEntry.revision : null;
            if (lastRevision != null) {
                this.selectedModification.timestamp = lastHistoryEntry.timestamp;
                this.selectedModification.username = lastHistoryEntry.username;
                getRevision({id: this.horse.id, revision: lastRevision}).then((response) => {
                    this.selectedVersion = response.data;
                });
            }
        }));

    },

    methods: {
        showChangesHistory(event) {
            if (event?.data?.revision) {
                getRevision({id: this.horse.id, revision: event.data.revision}).then((response) => {
                    this.selectedVersion = response.data;
                    this.selectedModification.timestamp = event?.data?.timestamp;
                    this.selectedModification.username = event?.data?.username;
                });
            }
        }
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
    .selectedVersion {
        background: var(--dates-background-color);
        color: var(--dates-text-color);
        border-radius: 7px;
    }
    .label {
        font-weight: 400;
        text-transform: uppercase;
        padding-right: 10px;
    }
    .horse-data {
        color: var(--text-color);
    }
    .notes {
        white-space: pre-wrap;
    }
</style>
